import { IOsiCreateCorrectionFeatureViewModel } from '@shared/types/mobx/features/OsiCorrection';
import { inject, injectable } from 'inversify';
import { makeAutoObservable } from 'mobx';
import { Abonent } from '@shared/types/osi/abonents';
import { ServiceGroupResponse } from '@shared/types/osi/services';
import logger from 'js-logger';
import { notifications } from '@shared/utils/notifications';
import api from '@app/api';
import { getOsiAbonents } from '@shared/api/osi/abonents/get';
import { ProfileModule } from '@mobx/services/profile';
import { type OsiService, OsiServiceIdentifier } from '@shared/types/mobx/services/osi';

@injectable()
export class OsiCreateCorrectionFeatureViewModel implements IOsiCreateCorrectionFeatureViewModel {
  abonents: Abonent[] = [];

  groups: ServiceGroupResponse[] = [];

  isDialogOpen = false;

  user: any;

  isLoading = false;

  constructor(@inject(OsiServiceIdentifier) private osiModule: OsiService, private profileModule: ProfileModule) {
    makeAutoObservable(this);

    this.loadGroups();
    this.loadAbonents();
  }

  private _onSuccessCb = () => {};

  set onSuccessCb(value: () => Promise<void>) {
    this._onSuccessCb = value;
  }

  closeDialog = async (event?: any, reason?: string): Promise<void> => {
    if (reason === 'backdropClick') return;
    this.isDialogOpen = false;
  };

  openDialog = async (): Promise<void> => {
    this.isDialogOpen = true;
  };

  createCorrection = async (values: any): Promise<void> => {
    try {
      if (this.isLoading) return;

      this.isLoading = true;

      const userId = this.profileModule.userData.id;

      const service = {
        serviceId: values.service?.service_id,
        sum: parseFloat(values.amount)
      };

      const payload = {
        abonentNum: values.abonent.id,
        reason: values.reason,
        services: [service]
      };

      await api.PaymentCorrectionCreate(userId, payload);

      await this.closeDialog();
      await this._onSuccessCb?.();

      notifications.success();
    } catch (e) {
      logger.error(e);
      notifications.error();
    } finally {
      this.isLoading = false;
    }
  };

  loadGroups = async (): Promise<void> => {
    try {
      if (!this.osiModule.osiId) throw new Error('osiId is undefined');
      this.isLoading = true;

      // @ts-expect-error api not typed
      this.groups = await api.GetGroupsAndServicesForFixes(this.osiModule.osiId);
    } catch (e) {
      logger.error(e);
      notifications.error();
    } finally {
      this.isLoading = false;
    }
  };

  private loadAbonents = async () => {
    try {
      if (!this.osiModule.osiId) throw new Error('osiId is undefined');
      this.isLoading = true;
      this.abonents = await getOsiAbonents(this.osiModule.osiId);
    } catch (e) {
      logger.error(e);
      notifications.error();
    } finally {
      this.isLoading = false;
    }
  };
}
